import PurseHand from '../../src/legacy/PurseHand';
export default PurseHand;
